import {Header, HeaderProvider} from './components/Header'
export * from  './components/Footer'

export const HeaderWithProvider = () => {
    return (
            <HeaderProvider>
                <Header/>
            </HeaderProvider>
    )
}
